<div class="stock-modal-backdrop" *ngIf="isVisible" (click)="close()" (keydown.escape)="close()" tabindex="-1"
  aria-hidden="false">
  <section class="stock-modal-panel detail-modal-panel" role="dialog" aria-modal="true"
    aria-labelledby="stock-detail-modal-title" (click)="$event.stopPropagation()">
    <div class="modal-layout detail-layout">
      <div class="full-width">
        <div class="role-banner" [class.viewer]="!isAdmin" [class.admin]="isAdmin">
          {{ isAdmin ? 'Chế độ quản trị' : 'Chế độ xem và ký hợp đồng' }}
        </div>

        <div class="info-header">
          <div>
            <h2 id="stock-detail-modal-title">Chi tiết kế hoạch / kho hàng</h2>
            <p class="sub-text">
              Xem thông tin chi tiết các kho, hình ảnh và tổng kết giá trị kho
            </p>
          </div>
        </div>

        <div class="loading-state" *ngIf="loadingDetail">Đang tải dữ liệu...</div>
        <div class="error-state" *ngIf="errorMessage">{{ errorMessage }}</div>

        <div class="detail-block" *ngIf="!loadingDetail">
          <div class="form-row">
            <div class="form-field readonly-field">
              <span>
                <span class="info-value">Tiêu đề: </span>
                <span class="info-label">{{ detailData.title || '' }}</span>
              </span>
            </div>

            <div class="form-field readonly-field">
              <span>
                <span class="info-value">Tên kho: </span>
                <span class="info-label">{{ detailData.warehouseName || '' }}</span>
              </span>
            </div>
          </div>

          <div class="form-field readonly-field">
            <span>
              <span class="info-value">Mô tả chung: </span>
              <span class="info-value">{{ detailData.description || '' }}</span>
            </span>
          </div>

          <div class="section-header">
            <h3>Danh sách kho</h3>
          </div>

          <div class="item-list">
            <div class="item-card" *ngFor="let item of (detailData.items || []); let i = index; trackBy: trackByIndex">
              <div class="item-card-header">
                <h4>Kho {{ i + 1 }} <span class="item-id">#{{ item.id || '—' }}</span></h4>
                <div class="item-header-actions">
                  <div class="item-status-summary">
                    <span class="item-status-label" [class.text-success]="item.isActive">
                      {{ item.isActive ? 'Đang mở bán' : 'Đang khóa' }}
                    </span>
                    <span class="item-status-separator">|</span>
                    <span [class.text-gray-400]="(item.buyers?.length || 0) > 0">
                      {{ (item.buyers?.length || 0) > 0 ? '' : 'Chọn' }}
                    </span>
                  </div>
                  <input type="checkbox" class="item-status-tick" *ngIf="!isCurrentUserOwner(item)"
                    [(ngModel)]="item.isChecked" [attr.aria-label]="'Chọn mua kho'" />
                  <span class="item-purchased-badge" *ngIf="isCurrentUserOwner(item)">
                    <i class="fa fa-check" aria-hidden="true"></i> Đã mua
                  </span>
                </div>
              </div>
              <div class="item-body">
                <div class="item-media">
                  <div class="upload-block">
                    <div class="upload-header">
                      <h5>{{ (activePreviewIndexByItem[i] || 0) + 1 }}/{{ getPreviewItems(i)?.length || 0 }}</h5>
                    </div>

                    <div class="preview-stage" *ngIf="getActivePreview(i) as preview; else noPreview">
                      <div class="preview-media" (swipeleft)="onSwipeLeft(i)" (swiperight)="onSwipeRight(i)">
                        <button *ngIf="getPreviewItems(i).length > 1" type="button" class="preview-nav preview-nav-prev"
                          (click)="onSwipeRight(i)" aria-label="Ảnh trước">
                          ‹
                        </button>

                        <img *ngIf="preview.type.startsWith('image/')" [src]="preview.preview" [alt]="preview.name" />

                        <video *ngIf="preview.type.startsWith('video/')" [src]="preview.preview" controls></video>

                        <button *ngIf="getPreviewItems(i).length > 1" type="button" class="preview-nav preview-nav-next"
                          (click)="onSwipeLeft(i)" aria-label="Ảnh kế tiếp">
                          ›
                        </button>
                      </div>

                      <div class="preview-dots" *ngIf="getPreviewItems(i).length > 1">
                        <button type="button" class="preview-dot"
                          *ngFor="let p of getPreviewItems(i); let pIndex = index"
                          [class.is-active]="pIndex === activePreviewIndexByItem[i]"
                          (click)="setActivePreview(i, pIndex)" [attr.aria-label]="'Xem tệp ' + (pIndex + 1)"></button>
                      </div>


                    </div>

                    <ng-template #noPreview>
                      <div class="preview-empty">Kho này chưa có ảnh</div>
                    </ng-template>
                  </div>
                </div>

                <div class="item-fields">
                  <div class="form-row form-row-1">
                    <div class="form-field readonly-field">
                      <span>{{ item.name || '' }}</span>
                    </div>
                  </div>

                  <div class="form-row form-row-type-unit">
                    <div class="form-field readonly-field field-type">
                      <span>Loại sản phẩm : {{ item.type || '' }}</span>
                    </div>

                    <div class="form-field readonly-field field-unit">
                      <span>Đơn vị : {{ item.unit || '' }}</span>
                    </div>
                  </div>

                  <div class="form-row form-row-4">

                    <div class="form-field readonly-field field-quantity">
                      <span class="required-label">Số lượng</span>
                      <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="12" placeholder="0"
                        [value]="item.quantity || 0" (input)="onQuantityChange($event, i)" />
                    </div>

                    <div class="form-field readonly-field field-retail">
                      <span>Giá bán lẻ: {{ item.retailPrice || 0 | number:'1.0-0' }} </span>
                    </div>

                    <div class="form-field readonly-field field-wholesale">
                      <span>Tổng nhập sỉ: {{ formatCurrency(getItemWholesale(item)) }} </span>
                    </div>

                    <div class="form-field readonly-field field-sold">
                      <span>Số lượng đã bán: {{ (item.soldQty || 0) | number:'1.0-0' }}</span>
                    </div>
                  </div>

                  <div class="form-field readonly-field">
                    <span>{{ item.note || '' }}</span>
                  </div>

                  <div class="item-summary">
                    <div class="summary-chip">
                      <span>Doanh thu bán lẻ</span>
                      <strong>{{ formatCurrency(getItemRevenue(item)) }}</strong>
                    </div>

                    <div class="summary-chip">
                      <span>Vốn nhập</span>
                      <strong>{{ formatCurrency(getItemWholesale(item)) }}</strong>
                    </div>

                    <div class="summary-chip profit">
                      <span>Lợi nhuận</span>
                      <strong>{{ formatCurrency(getItemProfit(item)) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grand-summary">
            <h3>TỔNG KẾT GIÁ TRỊ KHO HÀNG</h3>

            <div class="grand-summary-grid">
              <div class="grand-box">
                <span>Tổng doanh thu</span>
                 <strong>{{ formatCurrency(getTotalRevenue()) }}</strong>
              </div>

              <div class="grand-box">
                <span>Tổng vốn nhập</span>
                <strong>{{ formatCurrency(getTotalWholesale()) }}</strong>
              </div>

              <div class="grand-box highlight">
                <span>Tổng lợi nhuận</span>
                <strong>{{ formatCurrency(getTotalProfit()) }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="button close-button" (click)="close()" [disabled]="signing">
            Đóng
          </button>

          <button *ngIf="canShowContractButton" type="button" class="contract-btn" (click)="handleContractClick()"
            [disabled]="isContractDisabled">
            {{ contractButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="contract-modal-backdrop" *ngIf="isContractModalVisible" (click)="closeContractModal()">
  <section class="contract-modal-panel" role="dialog" aria-modal="true" aria-labelledby="contract-modal-title"
    (click)="$event.stopPropagation()">
    <div class="contract-modal-header">
      <div>
        <h2 id="contract-modal-title">{{ contractContent.title }}</h2>
        <p>Vui lòng đọc kỹ nội dung trước khi xác nhận ký hợp đồng</p>
      </div>

      <button type="button" class="contract-close-btn" (click)="closeContractModal()" aria-label="Đóng">
        ×
      </button>
    </div>

    <div class="contract-modal-body">
      <div class="contract-section">
        <h3>{{ contractContent.title }}</h3>
        <p *ngFor="let line of contractContent.commitment">{{ line }}</p>
      </div>

      <div class="contract-section">
        <h3>{{ contractContent.projectTitle }}</h3>
        <h4>{{ contractContent.projectSubtitle }}</h4>

        <div class="contract-block" *ngFor="let section of contractContent.projectSections">
          <h5>{{ section.title }}</h5>

          <p *ngFor="let p of section.paragraphs">{{ p }}</p>

          <ul *ngIf="section.bullets.length">
            <li *ngFor="let bullet of section.bullets">{{ bullet }}</li>
          </ul>

          <p *ngFor="let p of section.paragraphs2">{{ p }}</p>

          <ul *ngIf="section.bullets2?.length">
            <li *ngFor="let bullet of section.bullets2">{{ bullet }}</li>
          </ul>
        </div>
      </div>

      <div class="contract-section">
        <h3>{{ contractContent.regulationTitle }}</h3>
        <h4>{{ contractContent.regulationSubtitle }}</h4>

        <div class="contract-block" *ngFor="let rule of contractContent.regulations">
          <h5 [class.contract-subsection]="rule.isSection">{{ rule.title }}</h5>

          <ul *ngIf="rule.bullets?.length">
            <li *ngFor="let bullet of rule.bullets">{{ bullet }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contract-modal-footer">
      <button type="button" class="ghost-btn" (click)="closeContractModal()" [disabled]="signing">
        Đóng
      </button>

      <button type="button" class="contract-btn" (click)="signContract()" [disabled]="signing">
        <span *ngIf="!signing">Tôi đã đọc và đồng ý ký hợp đồng</span>
        <span *ngIf="signing">⏳ Đang xác nhận...</span>
      </button>
    </div>
  </section>
</div>

<app-auth-dialog (loggedIn)="handleAuthLoggedIn()"></app-auth-dialog>